/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "From now on, these agents may take actions oneAI recognises as irreversible — deleting data, merging changes, restarting devices — without anyone approving t..." |
*
* @param {Agent_Policy_Destructive_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_confirm_description = /** @type {((inputs?: Agent_Policy_Destructive_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ab sofort dürfen diese Agenten Aktionen, die oneAI als unumkehrbar erkennt — Daten löschen, Änderungen zusammenführen, Geräte neu starten —, ohne Freigabe ausführen. Sie sind dafür markiert, daher werden sie durch das Aktivieren wieder wirksam. Bestätigen Sie, dass das so gewollt ist.")
	return /** @type {LocalizedString} */ ("From now on, these agents may take actions oneAI recognises as irreversible — deleting data, merging changes, restarting devices — without anyone approving them. They are marked for it, so switching this on reactivates them. Confirm that this is intended.")
});